import { render, staticRenderFns } from "./PainelAdm.vue?vue&type=template&id=1f1aff3a"
import script from "./PainelAdm.vue?vue&type=script&lang=js"
export * from "./PainelAdm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports